window.addEventListener("DOMContentLoaded", function () {
  const modalButtons = document.querySelectorAll(".waitlist-button");
  modalButtons.forEach((button) =>
    button.addEventListener("click", (e) => {
      e.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'TQ5xjH']);
    })
  );
});
